import {
  GET_DOCUMENT_DATA,
  FETCH_DOCUMENT_META_ERROR,
  FETCH_DOCUMENT_META_START,
  FETCH_DOCUMENT_META_SUCCESS,
  FETCH_DOCUMENT_FILE_ERROR,
  FETCH_DOCUMENT_FILE_SUCCESS,
  FETCH_TRANSLATION,
  GET_TRANSLATION_FILE,
  FETCH_TRANSLATION_ERROR,
} from './types';
import { DocumentMetaType } from 'types/document';
import { TranslationType } from 'types/translation';

export interface IFetchDocumentMetaStart {
  type: typeof FETCH_DOCUMENT_META_START;
}

export interface IFetchDocumentMetaSuccess {
  type: typeof FETCH_DOCUMENT_META_SUCCESS;
  documentMeta: DocumentMetaType;
}

export interface IFetchDocumentMetaError {
  type: typeof FETCH_DOCUMENT_META_ERROR;
  error: {
    message: string;
    statusCode: number;
  };
}

export interface IFetchDocumentFileSuccess {
  type: typeof FETCH_DOCUMENT_FILE_SUCCESS;
}

export interface IFetchDocumentFileError {
  type: typeof FETCH_DOCUMENT_FILE_ERROR;
  error: {
    message: string;
    statusCode: number;
  };
}

export interface IFetchDocumentDataAction {
  type: typeof GET_DOCUMENT_DATA;
  documentId: string;
  documentVersion: string;
}

export interface IFetchTranslation {
  type: typeof FETCH_TRANSLATION;
  lang: TranslationType;
}

export interface IFetchGetTranslationAction {
  type: typeof GET_TRANSLATION_FILE;
}

export interface IFetchTranslationFileError {
  type: typeof FETCH_TRANSLATION_ERROR;
  error: {
    message: string;
    statusCode: number;
  };
}

export function fetchDataAction(
  documentId: string,
  documentVersion: string
): IFetchDocumentDataAction {
  return {
    type: GET_DOCUMENT_DATA,
    documentId,
    documentVersion,
  };
}

export function fetchDocumentMetaStartAction(): IFetchDocumentMetaStart {
  return {
    type: FETCH_DOCUMENT_META_START,
  };
}

export function fetchDocumentMetaSuccessAction(
  documentMeta: DocumentMetaType
): IFetchDocumentMetaSuccess {
  return {
    type: FETCH_DOCUMENT_META_SUCCESS,
    documentMeta,
  };
}

export const ERROR_MESSAGE =
  'Error happened while loading, try reloading the page';

export function fetchDocumentMetaErrorAction(
  statusCode: number,
  message = ERROR_MESSAGE
): IFetchDocumentMetaError {
  return {
    type: FETCH_DOCUMENT_META_ERROR,
    error: {
      message,
      statusCode,
    },
  };
}

export function fetchDocumentFileSuccessAction(): IFetchDocumentFileSuccess {
  return {
    type: FETCH_DOCUMENT_FILE_SUCCESS,
  };
}

export const FILE_ERROR_MESSAGE =
  'Error happened while loading pdf, try reloading the page';

export function fetchDocumentFileErrorAction(
  message = FILE_ERROR_MESSAGE,
  statusCode = 403
): IFetchDocumentFileError {
  return {
    type: FETCH_DOCUMENT_FILE_ERROR,
    error: {
      message,
      statusCode,
    },
  };
}

export function fetchTranslationAction(
  lang: TranslationType
): IFetchTranslation {
  return {
    type: FETCH_TRANSLATION,
    lang,
  };
}

export function fetchGetTranslationAction(): IFetchGetTranslationAction {
  return {
    type: GET_TRANSLATION_FILE,
  };
}

export const TRANSLATION_ERROR_MESSAGE =
  'Error happened while loading translation, try reloading the page';

export function fetchTranslationFileErrorAction(
  statusCode: number,
  message = TRANSLATION_ERROR_MESSAGE
): IFetchTranslationFileError {
  return {
    type: FETCH_TRANSLATION_ERROR,
    error: {
      message,
      statusCode,
    },
  };
}
